import styled from 'styled-components';
import { palette } from 'styled-tools';

export const TabContainer = styled.div`
    border-radius: 8px;
    border: 2px solid ${palette('transparent')};
    background-color: ${palette('gray_opacity_200')};
    height: 32px;
    display: flex;
    align-items: center;
`;